/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardType } from './RewardType';
import {
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    RewardTypeToJSONTyped,
} from './RewardType';
import type { AmountUnit } from './AmountUnit';
import {
    AmountUnitFromJSON,
    AmountUnitFromJSONTyped,
    AmountUnitToJSON,
    AmountUnitToJSONTyped,
} from './AmountUnit';

/**
 * 
 * @export
 * @interface RewardResponseObject
 */
export interface RewardResponseObject {
    /**
     * 
     * @type {RewardType}
     * @memberof RewardResponseObject
     */
    rewardType: RewardType;
    /**
     * 
     * @type {AmountUnit}
     * @memberof RewardResponseObject
     */
    amountUnit?: AmountUnit;
    /**
     * 
     * @type {number}
     * @memberof RewardResponseObject
     */
    amount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RewardResponseObject
     */
    promoDescriptions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RewardResponseObject
     */
    nftUri?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardResponseObject
     */
    nftMintDate?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardResponseObject
     */
    nftName?: string;
}



/**
 * Check if a given object implements the RewardResponseObject interface.
 */
export function instanceOfRewardResponseObject(value: object): value is RewardResponseObject {
    if (!('rewardType' in value) || value['rewardType'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function RewardResponseObjectFromJSON(json: any): RewardResponseObject {
    return RewardResponseObjectFromJSONTyped(json, false);
}

export function RewardResponseObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardResponseObject {
    if (json == null) {
        return json;
    }
    return {
        
        'rewardType': RewardTypeFromJSON(json['rewardType']),
        'amountUnit': json['amountUnit'] == null ? undefined : AmountUnitFromJSON(json['amountUnit']),
        'amount': json['amount'],
        'promoDescriptions': json['promoDescriptions'] == null ? undefined : json['promoDescriptions'],
        'nftUri': json['nftUri'] == null ? undefined : json['nftUri'],
        'nftMintDate': json['nftMintDate'] == null ? undefined : json['nftMintDate'],
        'nftName': json['nftName'] == null ? undefined : json['nftName'],
    };
}

export function RewardResponseObjectToJSON(json: any): RewardResponseObject {
    return RewardResponseObjectToJSONTyped(json, false);
}

export function RewardResponseObjectToJSONTyped(value?: RewardResponseObject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewardType': RewardTypeToJSON(value['rewardType']),
        'amountUnit': AmountUnitToJSON(value['amountUnit']),
        'amount': value['amount'],
        'promoDescriptions': value['promoDescriptions'],
        'nftUri': value['nftUri'],
        'nftMintDate': value['nftMintDate'],
        'nftName': value['nftName'],
    };
}

